import { useEffect } from 'react'
import storeConnect from 'Checkout/Redux/Connect'
import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import { paymentSetData } from 'Checkout/Redux/Actions/Payment'
import { TripInsuranceContainer } from 'Checkout/Components/Shared/TripInsurance'
import tripInsuranceQuery from './TripInsuranceQuery'

const TripInsuranceWrapper = ({ dynamicPrices, dayUse, discountId, productsPurchased, reservation, rigLength,
                                rigWidth, setIsTripProtection, setTripProtectionQuote, siteType, slug,
                                isTripProtection, total, totalSavings, tripProtectionQuote }) => {
  const [getPrice, { data, loading }] = useLazyQueryNoCache(tripInsuranceQuery)
  const tripProtectionQuoteToShow = loading ? '$10.00' : tripProtectionQuote

  const fetchPrice = () => {
    const { from, extras: { guests, isSiteLock, siteId }, rateId, to } = reservation
    const filters = { maxLength: rigLength, maxWidth: rigWidth, types: [siteType?.type] }
    const extras = { discountClubId: discountId, filters, guests, isSiteLock, productsPurchased, siteId }
    const variables = { dynamicPrices: JSON.stringify(dynamicPrices), from, rateId, slug, to, extras,
                        tripCost: total?.amount }
    const tripInsuranceQueryArgs = { variables }

    getPrice(tripInsuranceQueryArgs)
  }

  useEffect(() => {
    if (reservation && !dayUse) fetchPrice()
  }, [totalSavings, reservation?.nanoId])

  useEffect(() => {
    if (data) setTripProtectionQuote(data?.campground?.tripInsurancePrice)
  }, [data])

  return <TripInsuranceContainer {...{ loading, setIsTripProtection, isTripProtection,
                                       tripProtectionQuote: tripProtectionQuoteToShow }} />
}

const mapStateToProps = state => ({
  dayUse: state.search.dayUse,
  discountId: state.payment.discount?.id,
  dynamicPrices: state.cart.dynamicPrices,
  isTripProtection: state.payment.isTripProtection,
  productsPurchased: state.details.productsPurchased,
  reservation: state.cart.reservations[0],
  rigLength: state.search.rigLength,
  rigWidth: state.search.rigWidth,
  siteType: state.search.siteType,
  slug: state.campground.slug,
  total: state.cart.pricing.data?.reservations[0]?.pricing?.camperSubtotal,
  totalSavings: state.cart.pricing.data.totalSavings,
  tripProtectionQuote: state.payment.tripProtectionQuote,
})

const mapDispatchToProps = dispatch => ({
  setTripProtectionQuote: tripProtectionQuote => dispatch(paymentSetData({ tripProtectionQuote })),
  setIsTripProtection: isTripProtection => dispatch(paymentSetData({ isTripProtection })),
})

export default storeConnect({ mapStateToProps, mapDispatchToProps })(TripInsuranceWrapper)
